export var SEARCH_ROUTE_PATH = '/search';
export var COUNTRY_ROUTE_PATH = '/countries';
export var COUNTRY_ROUTE_COUNTRY_CODE_VARIABLE_NAME = 'countryCode';
export var AUTH_ROUTE_PATH = '/login';
export var AUTH_SIGNUP_ROUTE_PATH = '/signup';
export var AUTH_RESET_PASSWORD_ROUTE_PATH = '/reset-password';
export var FOUR_OH_FOUR_ROUTE_PATH = '/404';